import React, { useEffect, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';

const InputCurrency = ({
  prefix = '',
  decimalSeparator = ',',
  decimalsLimit = 2,
  decimalScale = 2,
  onChange,
  value,
  onFocus,
  ...rest
}) => {
  const [userValue, setUserValue] = useState(value);

  const triggerChange = (changedValue) => {
    onChange?.(
      changedValue ? parseFloat(changedValue.replace(decimalSeparator, '.')) : 0
    );
    setUserValue(changedValue);
  };

  const handleOnFocus = (e) => {
    e.target.select();

    if (onFocus) {
      onFocus(e);
    }
  };

  useEffect(() => {
    setUserValue(value ?? 0);
  }, [value]);

  return (
    <CurrencyInput
      className="ant-input"
      prefix={prefix}
      decimalScale={decimalScale}
      decimalSeparator={decimalSeparator}
      decimalsLimit={decimalsLimit}
      allowNegativeValue={false}
      onValueChange={triggerChange}
      value={userValue}
      onFocus={handleOnFocus}
      {...rest}
    />
  );
};
export default InputCurrency;
